var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',{attrs:{"color":"transparent"}},[_vm._v("Something has gone wrong there. Please contact support")])}
var staticRenderFns = []

export { render, staticRenderFns }